import React, { Fragment } from "react";
import Sticky from "react-stickynode";
import { ThemeProvider } from "styled-components";
import { interiorTheme } from "common/theme/interior";
import { DrawerProvider } from "common/contexts/DrawerContext";
import Navbar from "containers/Interior/Navbar";
import Footer from "containers/Interior/Footer";
import Heading from "common/components/Heading";
import BlogPost from "common/components/BlogPost";
import { ResetCSS } from "common/assets/css/style";
import {
  GlobalStyle,
  InteriorWrapper,
  ContentWrapper,
  BodyWrapper,
} from "containers/Interior/interior.style";
import SEO from "components/seo";

export default () => {
  return (
    <ThemeProvider theme={interiorTheme}>
      <Fragment>
        <SEO title="Partnership with Pošta Slovenije" />
        <ResetCSS />
        <GlobalStyle />

        {/* Start writing your markup from here. */}
        <InteriorWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <ContentWrapper>
            <BodyWrapper>
              <Heading as="h1" content="Newsroom" />
              <br />
              <br />
              <a href="/postparcel">
                <BlogPost
                  key="0"
                  title="Direct4me, start-up finalist at Parcel + Post Expo Amsterdam 2019"
                  excerpt="Direct4me visited Parcel + Post Expo Amsterdam 2019 and
                  showcased last-mile solution."
                />
              </a>
              <br />
              <br />
              <a href="/merkur">
                <BlogPost
                  key="1"
                  title="Direct4me Click and Collect solution"
                  excerpt="Direct4me as the perfect Click and Collect solution for
                  Curbside"
                />
              </a>
              <br />
              <br />
              <a href="/posta">
                <BlogPost
                  key="2"
                  title="Partnership with Pošta Slovenije"
                  excerpt="Direct4me and Pošta Slovenije are pleased to announce their
                strategic partnership. They combine Direct4me’s innovative
                parcel delivery solution with Pošta Slovenije (Post of Slovenia)
                last-mile service to improve pick-up and drop-off options."
                />
              </a>
            </BodyWrapper>
          </ContentWrapper>
          <Footer />
        </InteriorWrapper>
        {/* End of markup section. */}
      </Fragment>
    </ThemeProvider>
  );
};
